"use client";

import { useMemo } from "react";
import Image from "next/image";
import Link from "next/link";
import useNavItems from "@/app/hooks/nav-items.hook";
import { getActiveNavLogoUrl } from "@/app/utils/get-nav-logo-url";
import { DirectPaths } from "@/config/routes";
import { useAuth } from "@/context/authcontext";
import { useNavTheme } from "./nav-theme-context";

type NavBrandLogoProps = {
    active?: string;
    className?: string;
};

const toWhiteLogoUrl = (url: string) => {
    const original = url.substring(url.lastIndexOf("/"));
    return url.replace(original, "/white" + original);
};

const NavBrandLogo = ({ active = "", className }: NavBrandLogoProps) => {
    const theme = useNavTheme();
    const { isAuthenticated } = useAuth();
    const navItems = useNavItems({ active, isLoggedIn: Boolean(isAuthenticated) });

    const logoUrl = useMemo(() => {
        const defaultLogo = process.env.ICM_LOGO_URL ?? "";
        return getActiveNavLogoUrl(
            navItems,
            theme === "blue" ? toWhiteLogoUrl(defaultLogo) : defaultLogo,
            theme === "blue" ? toWhiteLogoUrl : undefined,
        );
    }, [navItems, theme]);

    return (
        <Link
            href={isAuthenticated ? DirectPaths.PLATFORM : DirectPaths.HOME}
            aria-label="InCred Money home"
        >
            <Image
                src={logoUrl}
                alt="InCred Logo"
                width={119}
                height={42}
                className={className ?? "h-[42px] w-auto shrink-0"}
            />
        </Link>
    );
};

export default NavBrandLogo;
